import { createReducer, on } from '@ngrx/store';
import { OrganisationState } from './organisation.state';
import { setSelectedOrganisation, setOrganisationUser, loadOrgIdFromLocalStorage, setOrgIdToLocalStorage, clearOrganisationContext } from './organisation.actions';
import { TokenStorageService } from '../../services/token-storage.service';

export const initialState: OrganisationState = {
  selectedOrganisation: null,
  organisationUser: null,
  orgId: null
};

// Local helper to choose storage based on impersonation mode
function getStorage() {
  const tss = new TokenStorageService();
  return tss.isImpersonationMode() ? sessionStorage : localStorage;
}

export const organisationReducer = createReducer(
  initialState,
  on(loadOrgIdFromLocalStorage, (state) => {
    const storage = getStorage();
    const orgId = storage.getItem('orgId');
    return { ...state, orgId };
  }),
  on(setOrgIdToLocalStorage, (state, { orgId }) => {
    const storage = getStorage();
    if (orgId) {
      storage.setItem('orgId', orgId);
    } else {
      storage.removeItem('orgId');
    }
    return { ...state, orgId };
  }),
  on(setSelectedOrganisation, (state, { selectedOrganisation }) => {
    const storage = getStorage();
    const orgId = selectedOrganisation?.id || state.orgId || null;

    // If a valid selectedOrganisation is provided, write orgId to storage (session for impersonation, local otherwise)
    if (selectedOrganisation?.id) {
      storage.setItem('orgId', selectedOrganisation.id);
    }

    // Note: Do NOT remove orgId when selectedOrganisation is null. Clearing should be explicit via clearOrganisationContext or logout flows.
    return {
      ...state,
      selectedOrganisation: selectedOrganisation || null,
      orgId
      // Keep organisationUser unchanged; it will be set explicitly via setOrganisationUser
    };
  }),
  on(setOrganisationUser, (state, { organisationUser }) => {
    return { ...state, organisationUser };
  }),
  on(clearOrganisationContext, (state) => {
    // Explicitly clear organisation context and remove orgId from storage
    const storage = getStorage();
    storage.removeItem('orgId');
    return { ...state, selectedOrganisation: null, organisationUser: null, orgId: null };
  })
);
